import AssignmentLesson from './AssignmentLesson';

export default AssignmentLesson;
